/**
 * @itemgo/service-rescue
 * ItemGo Service Rescue Plugin
 */

import { rescueManifest } from "./manifest.js";
import type { PluginModule } from "@itemgo/core";
import { calculateRescuePricing } from "./services/pricing.js";
import { useRescuePricing } from "./hooks/useRescuePricing.js";
import { RescuePricingBreakdown } from "./components/RescuePricingBreakdown.js";

export { rescueManifest };

export const rescuePlugin: PluginModule = {
  manifest: rescueManifest,
  services: {
    calculatePrice: calculateRescuePricing as unknown as (params: unknown) => Promise<unknown>,
  },
  hooks: {
    usePricing: useRescuePricing as unknown as () => unknown,
  },
  components: {
    PriceCalculator: RescuePricingBreakdown as unknown as React.ComponentType<unknown>,
  },
};

// Types
export type {
  RescuePricingConfig,
  RescuePricingInput,
  RescuePricingResult,
  RescueServiceData,
} from "./types.js";

// Schema
export { rescueSchema, breakdownTypes, vehicleLocations, tollOptions } from "./schema.js";
export type { RescueFormData } from "./schema.js";

// Services
export {
  calculateRescuePricing,
  formatPence,
  DEFAULT_RESCUE_PRICING_CONFIG,
} from "./services/pricing.js";

// React Hooks
export { useRescuePricing } from "./hooks/useRescuePricing.js";

// React Components
export { RescuePricingBreakdown } from "./components/RescuePricingBreakdown.js";
